
import WebService from "../WebService"
const Order = {
    action(data) {
        return WebService.post("/orders/" + data.order_id + "/status?e=" + data.e, data)
    },
    gets(params) {
        return WebService.get("/orders?" + params)
    },
    get(order_id) {
        return WebService.get("/orders/" + order_id)
    },
    summary(data) {
        return WebService.post("/orders/summary", data)
    },
    updateRemark(data) {
        return WebService.put("/orders/" + data.order_id, data)
    }
}
export default Order
